


















import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { moji2Hankana, moji2HanAlphaNum, hankana2Upper } from "@/types";

@Component
export default class AlphaNumHalfKanaTextField extends Vue {
  @Prop() public value!: string;
  @Prop({ required: false }) length!: number;

  @Emit()
  private input(value: string): string {
    return value;
  }
  @Emit()
  private onChange() {
    return;
  }
  private composing = false;
  private inputValue = "";

  private get Value(): string {
    this.inputValue = this.value;
    return this.inputValue;
  }
  private set Value(value: string) {
    this.inputValue = value;
    this.input(value);
  }

  private onKeyup() {
    if (!this.composing) {
      this.onInput(null);
    }
  }

  private onBlur() {
    this.onInput(null);
  }

  async onInput(event: Event | null) {
    if (this.composing) {
      return;
    }
    let str = await this.availableString(this.inputValue);
    // 濁点、半濁点で文字数がオーバーした場合はカット
    str = str.substr(0, this.length);
    this.Value = str;
  }

  // 変換中の判定
  private onComposition(composing: boolean) {
    this.composing = composing;
  }

  // 入力可能文字列変換
  private availableString(str: string): string {
    const slice = str.match(/.{1}/g);
    // 空の場合null
    if (slice == null) {
      return "";
    }
    let result = "";
    for (let i = 0; i < slice.length; i++) {
      result += this.availableCharactor(slice[i]);
    }
    return result;
  }

  private availableCharactor(str: string): string {
    // 入力可能文字へ変換
    str = moji2HanAlphaNum(str); //英数記号を半角
    str = str.toUpperCase(); //アルファベット大文字
    str = moji2Hankana(str); //かなをカタカナ半角
    str = hankana2Upper(str); //半角カナを大文字
    if (
      str.match(
        /^[0-9A-Zｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔｲﾕｴﾖﾗﾘﾙﾚﾛﾜｦﾝﾞﾟ()-. ]*$/
      )
    ) {
      return str;
    }
    // どれにも当てはまらない場合は空文字を返却
    return "";
  }
}
